export default __webpack_public_path__ + "static/media/Fish Health.fd6eb5fe.svg";